import React, { Component } from 'react';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input, Dropdown, MenuItem } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import Dropzone from 'react-dropzone';
import { browserHistory } from 'react-router';
import axios from 'axios';
import ReactPaginate from 'react-paginate';

import { UI_HEIGHT } from '../Common/constants';
import checkPermission from '../Common/permissions';
import FilterToolbar from '../Common/FilterToolbar';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { DateFormatter } from '../Common/dateFormat';
import { DatePicker } from '../Common/datePicker';
import GenericDatePicker from '../Common/GenericDatePicker';
import { SkyLightStateless } from 'react-skylight';
import { PriceTableModal } from '../Common/priceTableModal';
import { DateFormatter2 } from '../Common/dateFormat';
import GenericSelection from '../Common/GenericSelection';
import CustomerLogModal from '../Common/modals/generalManagement/CustomerLogModal';
import {
  isSUN, isDAICHEONG, isGGI, isOCM, isNS, isSV, isLMH, isSDR, isCRW, isLE, ROOT_URL, ROOT_API_URL,
  companyCodeTitle, isLAP, isARC, isSW, isHMM, isEKC, isSH
} from '../../actions/root_url';

const isEcity = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';

class Customers extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.customersPage,

      currentPage: 0,
      limit: isEcity ? null : 25,
      searchFilter: {
        CustomerNum: '',
        Name: '',
        SalesName: '',
        email: '',
        Description: '',
        IsWholesale: '',
        PriceLevel: '',
        IsActive: (isSV || isSH || true) ? "1" : '',
        MemberCard: '',
        Reseller: '',
        Telephone: '',
        Street: '',
        City: '',
        Old_Customer_id: '',
        BusinessType: '',
        State: '',
        CreateDateStart: '',
        CreateDateEnd: '',
        LastOrderDateStart: '',
        LastOrderDateEnd: '',
      },
      wholesaleDisplay: <Translate value="all" />,
      activeDisplay: (isSV || isSH || true) ? <Translate value="active" /> : <Translate value="all" />,
      limitDisplay: isEcity ? 'all' : '25',
      rows: [],
      selectedRows: null,
      filters: {},
      sortColumn: null,
      sortDirection: null,
      files: null,

      ptModalOpen: false,
      fjCustomerId: "",
      customerLogModalVisibility: false,
      giftcardModalVisibility: false,
      giftCustomer: {},
      reloadAmount: null,
      reloadNote: null,
      giftcardRows: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        selectedRows: [],
      },
    };
    this.openPTModal = this.openPTModal.bind(this);
    this.closePTModal = this.closePTModal.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.openGiftcardModal = this.openGiftcardModal.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    if (localStorage.getItem("custPage")) {
      this.setState({currentPage: Number(localStorage.getItem("custPage"))});
      this.props.fetchCustomersPaginate(Number(localStorage.getItem("custPage")), this.state.limit, this.state.searchFilter);
      setTimeout(() => {
        localStorage.setItem('custPage', 0);
      }, 1000);
    } else {
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }
    this.props.fetchBaseUsers();
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedCompany !== prevProps.selectedCompany) {
      this.props.fetchBaseUsers();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // Once customers are ready, reset state.
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.customers && nextProps.customers !== this.props.customers) {
      this.setState({
        rows: nextProps.customers,
      });
    }
    if (this.props.selectedCompany !== nextProps.selectedCompany) {
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.customersPage });
  }

  onDrop(files) {
    if (files) {
      alert('Upload takes time, please stay on the current page');
    }
    this.props.attachDocument(files);
    this.setState({
      files,
    });
  }

  // Helper function to render an icon for the stock statues of customer.
  renderIsActive(isActive) {
    if (isActive) { return <span className="label label-success"><Translate value="active" /></span>; }
    return <span className="label label-danger"><Translate value="inactive" /></span>
  }

  renderIsWholesale(isWholeSale) {
    if (isWholeSale) { return <span className="label label-success"><Translate value="yes" /></span>; }
    return (<span className="label label-danger"><Translate value="no" /></span>);
  }

  // Set customer being selected to be currentCustomer and navigate user to the edit page
  setCurrentCustomer(e) {
    e.preventDefault();
    localStorage.setItem('custPage', this.state.currentPage);
    const currentCustomer = this.state.selectedRows[0];
    const customerFromOriginalData = this.props.customers.filter(customer => customer.Customer_id === currentCustomer.Customer_id)[0];
    this.props.resetCurrentCustomer();
    this.props.selectCustomer(customerFromOriginalData);
    this.context.router.push('/customers/' + customerFromOriginalData.Customer_id);
  }

  editCurrentCustomer(value) {
    // e.preventDefault();
    // const currentCustomer = this.state.selectedRows[0];
    localStorage.setItem('custPage', this.state.currentPage);
    let currentCustomer = value;
    const customerFromOriginalData = this.props.customers.filter(customer => customer.Customer_id === currentCustomer.Customer_id)[0];
    this.props.resetCurrentCustomer();
    this.props.selectCustomer(customerFromOriginalData);
    this.context.router.push('/customers/' + customerFromOriginalData.Customer_id);
  }

  // Reset the currentCustomer and navigate to the create page
  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentCustomer();
    this.context.router.push('/customers/new');
  }

  openPTModal() {
    this.setState({ ptModalOpen: true });
  }
  closePTModal() {
    this.setState({ ptModalOpen: false });
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  renderTable() {
    if (this.props.isLoading && !this.props.error) {
      return (
        <ContentWrapper>
          <br />
          <Spinner />
        </ContentWrapper>
      );
    } else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
        </ContentWrapper>
      );
    }

    const modifiedRows = this.state.rows.map((customer) => {
      return {
        ...customer,
        IsActive: customer.IsActive ? 'active' : 'inactive',
        IsWholesale: customer.IsWholesale ? 'yes' : 'no',
      };
    });

    const getRows = () => {
      const data = {
        ...this.state,
        rows: modifiedRows,
      };
      return Data.Selectors.getRows(data);
    };

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    // Custom Formatter component
    const IsActiveFormatter = React.createClass({
      render() {
        if (this.props.value === 'active') { return <span className="label label-success"><Translate value="active" /></span>; }
        return <span className="label label-danger"><Translate value="inactive" /></span>;
      },
    });

    const IsWholesaleFormatter = React.createClass({
      render() {
        if (this.props.value === 'yes') { return <span className="label label-success"><Translate value="yes" /></span>; }
        return <span className="label label-danger"><Translate value="no" /></span>;
      },
    });

    // Handle the row select function
    const onRowSelect = (rows) => {
      this.setState({ selectedRows: rows });
    };

    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    // Column difinition
    const columns = [
      {
        key: 'CustomerNum',
        name: <Translate value="customer_no" />,
        width: 130,
        resizable: true,
        sortable: true,
        filterable: true,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: "100%", height: "100%" }}
            onDoubleClick={() => {
              if(checkPermission('change_customer')) {
                this.editCurrentCustomer(dependentValues);
              }
            }}
          >
            {value}
          </div>
        ),
      },
      ...isLAP ? [{
        key: 'Route_id',
        name: <Translate value="route_id" />,
        width: 100,
        resizable: true,
        sortable: true,
        filterable: true,
      }] : [],  
      ...isGGI ? [{
        key: 'Old_Customer_id',
        name: <Translate value="customer_id" />,
        width: 130,
        resizable: true,
        sortable: true,
        filterable: true,
      }] : [],
      {
        key: 'Name',
        name: <Translate value="name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: "100%", height: "100%" }}
            onDoubleClick={() => {
              this.editCurrentCustomer(dependentValues);
            }}
          >
            {value}
          </div>
        ),
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        width: isDAICHEONG ? 150 : 180,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      ...(isLMH || isSDR || isCRW) ? [{
        key: 'rating',
        name: <Translate value="rating" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }] : [],
      ...isOCM || isLAP ? [{
        key: 'SalesName',
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 150,
      }] : [],
      {
        key: 'Telephone',
        name: <Translate value="phone" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      ...isARC ? [{
        key: 'MemberCard',
        name: <Translate value="member_card" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 160,
        getRowMetaData: row => row,
        formatter: ({ value, dependentValues }) => (
          <a href={`${ROOT_URL}v1/customer/print_member/${dependentValues.Customer_id}?Bearer=${localStorage.getItem('token')}`} style={{cursor: "pointer", width: "100%", color: 'blue'}}>
            { value }
          </a>
        ),
      }] : [],
      ...isARC ? [{
        key: 'giftcard_balance',
        name: <Translate value="giftcard_balance" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }] : [],
      {
        key: 'Street',
        name: <Translate value="address" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 190,
      },
      {
        key: 'City',
        name: <Translate value="city" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: 'State',
        name: <Translate value="state" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 60,
      },
      ...isEcity ? [{
        key: 'City',
        name: <Translate value="city" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }] : [{
        key: 'Email',
        name: <Translate value="email" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      }],
      ...isDAICHEONG ? [{
        key: 'SalesName',
        name: <Translate value="sales_rep" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }] : [],
      ...isLE ? [{
        key: 'OrderType',
        name: <Translate value="order_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      }] : [],
      ...isGGI ? [{
        key: 'BusinessType',
        name: <Translate value="business_type" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 150,
      },
      {
        key: 'CreditStatus',
        name: <Translate value="credit_status" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: 'DelyStartTime',
        name: <Translate value="del_start_time" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: 'DelyEndTime',
        name: <Translate value="del_end_time" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      },
      {
        key: 'PDFAttached',
        name: <Translate value="pdf_attached" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
        formatter : ({value})=>(
          <div style={{cursor: "pointer", width: "100%", display: 'flex', justifyContent: 'center', color: value ? 'green' : 'red'}}>
            { value ? <em className="fa fa-check"></em> : <em className="fa fa-times"></em> }
          </div>
        )
      }, 
      {
        key: 'SalesName',
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }] : [],
      {
        key: 'CreateDate',
        name: <Translate value="create_date" />,
        width: 120,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'LastOrderDate',
        name: <Translate value="last_order" />,
        width: 120,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'IsWholesale',
        name: <Translate value="wholesale" />,
        width: 100,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: IsWholesaleFormatter,
      },
      {
        key: 'PriceLevel',
        name: <Translate value="price_lvl" />,
        width: 90,
        resizable: true,
        sortable: true,
        filterable: true,
      },
      {
        key: 'IsActive',
        name: <Translate value="active" />,
        width: 80,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: IsActiveFormatter,
      },
    ];

    if (isEcity) {
      const indexDescription = _.findIndex(columns, { key: 'Description' });
      const memberCardColumn = {
        key: 'MemberCard',
        name: <Translate value="member_card" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 130,
      };
      const resellerColumn = {
        key: 'Reseller',
        name: <Translate value="reseller" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 80,
      };
      columns.splice(indexDescription, 0, resellerColumn);
      columns.splice(indexDescription, 0, memberCardColumn);
    }

    return (
      // React Table Customers
      <div>
        <Row>
          <Col md={12}>
            <div id="Customers-dataGrid1" style={{ marginTop: (isSV || isLE) ? '85px' : '140px' }}>
              <ReactDataGrid
                rowKey="Customer_id"
                enableCellSelect={true}
                onGridSort={handleGridSort}
                // toolbar={<FilterToolbar enableFilter />}
                // onAddFilter={handleFilterChange}
                columns={columns}
                headerRowHeight={45}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={(isSV || isLE) ? this.state.tableHeight - 100 : this.state.tableHeight - 150}
                enableRowSelect="single"
                onRowUpdated={this.handleRowUpdated}
                onRowSelect={onRowSelect}
                minColumnWidth={300}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} >
            <div style={{ width: '630px' }} id="react-pagination">
              <ReactPaginate
                previousLabel={<Translate value="prev_page" />}
                nextLabel={<Translate value="next_page" />}
                containerClassName={'pagination'}
                activeClassName={'active'}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                pageCount={this.props.customerTotalPages}
                onPageChange={handleOnPageChange}
                forcePage={this.state.currentPage}
              />
            </div>
          </Col>
        </Row>
        <Row style={{ padding: '10px', paddingTop: '0px', fontSize: 'small' }}>
          <label>
            <Translate value="total_customers" />:&nbsp;
            <span className="font-color-orange">{this.props.customerTotalCount}</span>
          </label>
        </Row>
      </div>
    );
  }
  getUsers() {
    const Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.FirstName, label: user.FirstName });
    });
    return Users;
  }

  renderSearchFilter() {
    const isWholesaleSelection = [
      {
        label: <Translate value="all" />,
        value: '',
        name: 'IsWholesale',
      },
      {
        label: <Translate value="yes" />,
        value: '1',
        name: 'IsWholesale',
      },
      {
        label: <Translate value="no" />,
        value: '0',
        name: 'IsWholesale',
      },
    ]

    const isActiveSelection = [
      {
        label: <Translate value="all" />,
        value: '',
        name: 'IsActive',
      },
      {
        label: <Translate value="active" />,
        value: '1',
        name: 'IsActive',
      },
      {
        label: <Translate value="inactive" />,
        value: '0',
        name: 'IsActive',
      },
    ]

    const limitSelection = [
      {
        label: '25',
        value: 25,
        name: 'limit',
      },
      {
        label: '50',
        value: 50,
        name: 'limit',
      },
      {
        label: '100',
        value: 100,
        name: 'limit',
      },
      {
        label: <Translate value="all" />,
        value: null,
        name: 'limit',
      },
    ]

    const handleOnSubmit = (event) => {
      event.preventDefault();
    }

    const handleFilterChange = (event) => {
      this.state.currentPage = 0;
      let keys = Object.keys(this.state.searchFilter);
      for (let i = 0; i < keys.length; i++) {
        if (event.target.name === keys[i]) {
          this.state.searchFilter[keys[i]] = event.target.value;
        }
      }
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const handleFilterChangeDropdown = (el) => {
      this.state.currentPage = 0;
      let keys = Object.keys(this.state.searchFilter);
      for (let i = 0; i < keys.length; i++) {
        if (el.name === keys[i]) {
          this.state.searchFilter[keys[i]] = el.value;
          if (el.name === 'IsWholesale') {
            this.state.wholesaleDisplay = el.label;
          } else if (el.name === 'IsActive') {
            this.state.activeDisplay = el.label;
          }
        }
      }
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      this.props.fetchCustomersPaginate(this.state.currentPage, this.state.limit, this.state.searchFilter);
    }

    const renderOldCustomerIdField = () => {
      if (isGGI) {
        return <Col className="col-sm-3" style={{ width: '120px' }} >
        <Input name="Old_Customer_id" type="text" onChange={handleFilterChange} />
      </Col>
      }
    }


  const renderSalesSelection = () => {
    const Users = this.getUsers();
    const all = {value: '', label: <Translate value="all" />}
    Users.splice(0, 0, all);

    return (
      <div className="customer-sales">
        <GenericSelection
          options={Users}
          value={this.state.searchFilter.SalesName}
          setSelected={(e) => {
            handleFilterChangeDropdown({
              name: 'SalesName',
              value: e.value,
            })
          }}
        />
      </div>
    )
  }

  const renderBusinessTypeSelection = () => {
    let businessTypeOptions = [
      { label: <Translate value="supermarket" />, value: 'Supermarket' },
      { label: <Translate value="foodWholesale" />, value: 'Food Wholesale' },
      { label: <Translate value="wholesale" />, value: 'Wholesale' },
      { label: <Translate value="pharmacy" />, value: 'Pharmacy' },
      { label: <Translate value="restaurant" />, value: 'Restaurant' },
      { label: <Translate value="bakery" />, value: 'Bakery' },
      { label: <Translate value="ecommerce" />, value: 'Ecommerce' },
      { label: <Translate value="wechatBusiness" />, value: 'Wechat Business' },
    ];
    if (isSW) {
      businessTypeOptions = [
        { label: <Translate value="individual" />, value: 'Individual' },
        { label: <Translate value="convenienceStore" />, value: 'Convenience Store' },
        { label: <Translate value="retailer" />, value: 'Retailer' },
        { label: <Translate value="restaurant" />, value: 'Restaurant' },
        { label: <Translate value="manufacturer" />, value: 'Manufacturer' },
        { label: <Translate value="wholesalerDistributor" />, value: 'Wholesaler / Distributor' },
        { label: <Translate value="others" />, value: 'Others' },
      ]
    }
    if (isHMM) {
      businessTypeOptions = [
        { label: <Translate value="contractor" />, value: 'Contractor' },
        { label: <Translate value="builder" />, value: 'Builder' },
        { label: <Translate value="retailStore" />, value: 'Retail Store' },
        { label: <Translate value="wholesaleStore" />, value: 'Wholesale Store' },
      ]
    }
    if (isGGI) {
      businessTypeOptions = [
        { label: <Translate value="all" />, value: '', num: 0, abbr: "" },
        { label: <Translate value="1_wholesale_distributor_WH" />, value: 'Wholesale Distributor', num: 1, abbr: "WH" },
        { label: <Translate value="2_asia_supermarket_AS" />, value: 'Asia Supermarket', num: 2, abbr: 'AS' },
        { label: <Translate value="3_restaurant_RE" />, value: 'Restaurant', num: 3, abbr: 'RE' },
        { label: <Translate value="4_broker_trader_import_BK" />, value: 'Broker Trader Import', num: 4, abbr: 'BK' },
        { label: <Translate value="5_processor_prison_military_airline_school_club_PS" />, value: 'Processor Prison Military Airline School Club', num: 5, abbr: 'PS' },
        { label: <Translate value="6_none_asian_supermarket_NS" />, value: 'None Asian Supermarket', num: 6, abbr: 'NS' },
        { label: <Translate value="7_online_order_OO" />, value: 'Online Order', num: 7, abbr: 'OO' },
        { label: <Translate value="8_cash_carry_CC" />, value: 'Cash Carry', num: 8, abbr: 'CC' },
        { label: <Translate value="9_other_OT" />, value: 'Other', num: 9, abbr: 'OT' },
        { label: <Translate value="0_VIP_VP" />, value: 'VIP', num: 0, abbr:  "VP" },
      ]
    }
    if (isEKC || isLMH || isSDR || isCRW) {
      businessTypeOptions = [
        { label: <Translate value="wholesale" />, value: 'Wholesale' },
        { label: <Translate value="retail" />, value: 'Retail' },
        { label: <Translate value="construction" />, value: 'Construction' },
      ]
    }
    return (
      <div className="customer-sales">
        <GenericSelection
          options={businessTypeOptions}
          value={this.state.searchFilter.BusinessType}
          setSelected={(e) => {
            handleFilterChangeDropdown({
              name: 'BusinessType',
              value: e.value,
            })
          }}
        />
      </div>
    )
  }

    const renderOldCustomerIdLabel = () => {
      if(isGGI) {
        return <label className="col-sm-3" style={{ width: '120px' }}><Translate value="customer_id" /></label>
      }
    }

    // Customer No//Customer ID// Name//Description//City/State//Business Type(下拉框）//Sales（下拉框）//Create date//last order date//Active/display Limit（下拉框）
    return (
      <div style={{ width: '1400px' }}>
        <Row>
          <Col md={12}>
            <div className="form-group" style={{ marginBottom: '0px', marginTop: '30px', position: 'absolute', zIndex: 2 }} id="search-product-by">
              <form autoComplete='off' onSubmit={handleOnSubmit}>
                <Row>
                  <Col>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="customer_no" /></label>
                    {renderOldCustomerIdLabel()}
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="name" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="phone" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="description" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="city" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="state" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="business" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="sales" /></label>
                    <label className="col-sm-3" style={{ width: '115px' }}><Translate value="active" /></label>
                    <label className="col-sm-3" style={{ width: '90px' }}><Translate value="limit" /></label>
                    {/* <label className="col-sm-3" style={{ width: '120px' }}><Translate value="phone" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="address" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="email" /></label>
                    <label className="col-sm-3" style={{ width: '90px' }}><Translate value="wholesale" /></label>
                    <label className="col-sm-3" style={{ width: '120px' }}><Translate value="price_lvl" /></label> */}
                  </Col>
                </Row>
                <Row>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="CustomerNum" type="text" onChange={handleFilterChange} />
                  </Col>
                  {renderOldCustomerIdField()}
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="Name" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="Telephone" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="Description" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="City" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="State" type="text" onChange={handleFilterChange} />
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    {renderBusinessTypeSelection()}
                  </Col>
                  <Col className="col-sm-3" style={{ width: '120px' }} >
                    {/* <Input name="State" type="text" onChange={handleFilterChange} /> */}
                    {renderSalesSelection()}
                  </Col>
                  {/*<Col className="col-sm-3" style={{ width: '120px' }} >
                    <Input name="Street" type="text" onChange={handleFilterChange} />
                  </Col> */}
                  {/* <Col className="col-sm-3" style={{ width: '90px' }} >
                    <Dropdown>
                      <Dropdown.Toggle style={{ width: '75px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                        {this.state.wholesaleDisplay}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="super-colors">
                        {isWholesaleSelection.map(el => {
                          return (
                            <MenuItem onClick={() => handleFilterChangeDropdown(el)}>{el.label}</MenuItem>
                          )
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col> */}
                  <Col className="col-sm-3" style={{ width: '115px' }} >
                    <Dropdown>
                      <Dropdown.Toggle style={{ width: '100px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                        {this.state.activeDisplay}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="super-colors">
                        {isActiveSelection.map(el => {
                          return (
                            <MenuItem onClick={() => handleFilterChangeDropdown(el)}>{el.label}</MenuItem>
                          )
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                  <Col className="col-sm-3" style={{ width: '90px' }} >
                    <Dropdown>
                      <Dropdown.Toggle style={{ width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                        {this.state.limitDisplay}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="super-colors">
                        {limitSelection.map(el => {
                          return (
                            <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                          )
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </Row>
                {
                  !(isSV || isLE) &&
                  <Row>
                    <Col>
                      <label className="col-sm-6" style={{ width: '380px' }}><Translate value="create_date" /></label>
                      <label className="col-sm-6" style={{ width: '380px' }}><Translate value="last_order" /></label>
                    </Col>
                  </Row>
                }
                {
                  !(isSV || isLE) &&
                  <Row>
                    <Col className="col-sm-6" style={{ width: '380px' }} >
                      <Col className="col-sm-1" style={{ width: '30px' }}>
                        <label className="from-label" style={{ fontWeight: 400 }}>
                          <Translate value="from" />
                        </label>
                      </Col>
                      <Col className="col-sm-5" >
                        <GenericDatePicker 
                          setDate={(date) => {
                            handleFilterChangeDropdown({
                              name: 'CreateDateStart',
                              value: date,
                            })
                          }}
                          selectedDate={this.state.searchFilter.CreateDateStart}
                          clearable
                        />
                      </Col>
                      <Col className="col-sm-1" style={{ width: '20px' }}>
                        <label className="to-label" style={{ fontWeight: 400 }}>
                          <Translate value="to" />
                        </label>
                      </Col>
                      <Col className="col-sm-5">
                        <GenericDatePicker 
                          setDate={(date) => {
                            handleFilterChangeDropdown({
                              name: 'CreateDateEnd',
                              value: date,
                            })
                          }}
                          selectedDate={this.state.searchFilter.CreateDateEnd}
                          clearable
                        />
                      </Col>
                    </Col>
                    <Col className="col-sm-6" style={{ width: '380px' }} >
                      <Col className="col-sm-1" style={{ width: '30px' }}>
                        <label className="from-label" style={{ fontWeight: 400 }}>
                          <Translate value="from" />
                        </label>
                      </Col>
                      <Col className="col-sm-5" >
                        <GenericDatePicker 
                          setDate={(date) => {
                            handleFilterChangeDropdown({
                              name: 'LastOrderDateStart',
                              value: date,
                            })
                          }}
                          selectedDate={this.state.searchFilter.LastOrderDateStart}
                        />
                      </Col>
                      <Col className="col-sm-1" style={{ width: '20px' }}>
                        <label className="to-label" style={{ fontWeight: 400 }}>
                          <Translate value="to" />
                        </label>
                      </Col>
                      <Col className="col-sm-5">
                        <GenericDatePicker 
                          setDate={(date) => {
                            handleFilterChangeDropdown({
                              name: 'LastOrderDateEnd',
                              value: date,
                            })
                          }}
                          selectedDate={this.state.searchFilter.LastOrderDateEnd}
                        />
                      </Col>
                    </Col>
                  </Row>
                }
              </form>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  openCustomerLogModal = () => this.setState({customerLogModalVisibility: true})
  closeCustomerLogModal = () => this.setState({customerLogModalVisibility: false})
  renderCustomerLogBtn = () => {
    return <Button bsStyle="primary" disabled={false} onClick={() => this.openCustomerLogModal()}>
      <em className={`fa fa-file-text`} />
      <Translate value="conversation_log" />
    </Button>
  }

  handleClickMember = (value, row) => {
    if (value) {
      this.setState({ selectedRows: [row] });
    }
  }

  confirmReload = () => {
    let { selectedRows, reloadAmount, reloadNote } = this.state;
    let data = {        
      MemberCard: selectedRows[0].MemberCard,
          Order_Num: null,
          Order_id: null,
           amount: reloadAmount,
          transaction_type: "RELOAD",
          note: reloadNote,
          };

    axios({
      method: 'POST',
      data: data,
      url: `${ROOT_URL}v1/customer/giftcard/${selectedRows[0].MemberCard}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then((res) => {
        if (res.error) {
          alert(JSON.stringify(res.error));
        } else {
          alert("Card Reloaded!");
          this.setState({reloadAmount: null, reloadNote: null});
          this.fetchGiftcard();
        }
      });
  }

  fetchGiftcard = () => {
    let {selectedRows, giftcardRows, giftCustomer} = this.state;
    giftcardRows.rows = [];
    giftCustomer = {};
    if (selectedRows && selectedRows.length > 0) {
      axios.get(
        `${ROOT_URL}v1/customer/giftcard/${selectedRows[0].MemberCard}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
      .then(res => {
        if (res && res.data && res.data.customer && res.data.giftcard_transaction) {
          let sorted = res.data.giftcard_transaction.map(obj => { return { ...obj, CreateTime: new Date(obj.CreateTime) } }).sort((a, b) => b.CreateTime - a.CreateTime);
          sorted.map((r,i) => {
            giftcardRows.rows.push({CreateTime2: moment(r.CreateTime).format('MM-DD-YYYY HH:mm'), UpdateTime2: moment(r.UpdateTime).format('MM-DD-YYYY HH:mm'), ...r});
          });
          // giftcardRows.rows = res.data.giftcard_transaction;
          giftCustomer = res.data.customer;
        this.setState({giftcardRows, giftCustomer,});
        }
      }, (err) => {
        if (err.data) {
          alert(JSON.stringify(err.data));
        } else {
          alert("Server issue detected, please contact admin.");
        }
      })
    }
  }
  openGiftcardModal = () => {
    this.fetchGiftcard();
    this.setState({giftcardModalVisibility: true});
  }
  closeGiftcardModal = () => this.setState({giftcardModalVisibility: false})
  giftcardTransactionBtn = () => {
    return <Button bsStyle="primary" 
    disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !this.state.selectedRows[0].MemberCard}
    onClick={() => this.openGiftcardModal()}>
      <em className={`fa fa-file-text`} />
      <Translate value="giftcard_transactions" />
    </Button>
  }

  renderGiftcardTable() {
    // Parameters of the react-data-grid
    // const tableHeight = window.innerHeight < 930 ? 185 : 185;
    const tableHeight = 475;

    const getRows = () => Data.Selectors.getRows(this.state.giftcardRows);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      newRows.map((r) => {
        r.isSelected = false;
      });
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
      });
      const giftcardRows = {
        ...this.state.giftcardRows,
        rows: newRows,
        selectedRows: [rows[0].row],
      };
      this.setState({ giftcardRows });
    };
    
    const onRowsDeselected = (rows) => {
      const newRows = getRows();
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
      });
      const giftcardRows = {
        ...this.state.giftcardRows,
        rows: newRows,
        selectedRows: [],
      };
      this.setState({ giftcardRows });
    };

    const handleRowUpdated = (e) => {
      // merge updated row with current row and rerender by setting state
      const rows = getRows();
      Object.assign(rows[e.rowIdx], e.updated);
      const giftcardRows = {
        ...this.state.giftcardRows,
        rows,
      };
      this.setState({ giftcardRows });
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.giftcardRows, { sortColumn, sortDirection });
      this.setState({ giftcardRows: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const giftcardRows = { ...this.state.giftcardRows, filters: {} };
      this.setState({ giftcardRows });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.giftcardRows.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const giftcardRows = { ...this.state.giftcardRows, filters: newFilters };
      this.setState({ giftcardRows });
    };


    let columns =
      [
        {
          key: 'transaction_type',
          name: <Translate value="type" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'amount',
          name: <Translate value="amount" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Order_Num',
          name: <Translate value="order" />,
          resizable: true,
          sortable: true,
          width: 130,
          filterable: true,
        },
        {
          key: 'operator_name',
          name: <Translate value="operator" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'note',
          name: <Translate value="note" />,
          resizable: true,
          sortable: true,
          width: 180,
          filterable: true,
        },
        {
          key: 'CreateTime2',
          name: <Translate value="created" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
          // formatter: DateFormatter2,
        },
        {
          key: 'UpdateTime2',
          name: <Translate value="updated" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
          // formatter: DateFormatter2,
        },
        // {
        //   key: 'ImageURL2',
        //   name: <Translate value="pod" />,
        //   resizable: true,
        //   sortable: true,
        //   width: 110,
        //   filterable: true,
        //   // getRowMetaData: row => row,
        //   formatter: ({ value }) => {
        //     if (!value) return <span />
        //     return <a href={value} style={{width: '100%', display: 'flex', justifyContent: 'center'}}>Download</a>;
        //   }
        // },
        // {
        //   key: "ImageURL",
        //   name: <Translate value="image" />,
        //   resizeable: true,
        //   width: 300,
        //   sortable: false,
        //   editable: false,
        //   filterable: false,
        //   formatter: ({ value }) => (
        //     <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        //       <img style={{ height: '100px', objectFit: 'contain' }} src={value} />
        //     </div>
        //   ),
        //   getRowMetaData: (row) => row,
        // },
      ];
     
    // React Table Purchase Order Details
    return (
      <div style={{position: 'relative', top: '-32px'}}>
      <Row>
        <Col xs={12}>
          <div style={{marginBottom: '0px'}} className="recat-customizer" id="Giftcard-dataGrid2">
            <ReactDataGrid
              headerRowHeight={45}
              toolbar={<Toolbar enableFilter />}
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              minHeight={tableHeight}
              // enableRowSelect="single"
              // rowSelection={{
              //   showCheckbox: true,
              //   onRowsSelected,
              //   onRowsDeselected,
              //   selectBy: {
              //     isSelectedKey: 'isSelected',
              //   },
              // }}
              onRowUpdated={handleRowUpdated}
            />
          </div>
        </Col>
      </Row>
      </div>
    );
  }

  render() {
    const {
      selectedCompany,
    } = this.props;
    const height = (this.state.tableHeight + 70).toString();
    const tableCollapseFix = { height };
    const token = localStorage.getItem('token');
    const Company_id = selectedCompany ? selectedCompany.value : null;
    const excelUrl = `${ROOT_URL}v1/customer/export/?Bearer=${localStorage.getItem('token')}&Company_id=$${Company_id}`;
    const excelShippingUrl =  this.state.selectedRows && `${ROOT_URL}v1/customer/export_shipping/${this.state.selectedRows[0].Customer_id}?Bearer=${localStorage.getItem('token')}&Company_id=$${Company_id}`;
    const memberCardURL = this.state.selectedRows && `${ROOT_URL}v1/customer/print_member/${this.state.selectedRows[0].Customer_id}?Bearer=${token}`;
    
    if (this.state.selectedRows && this.state.selectedRows.length === 1) {
      this.state.fjCustomerId = this.state.selectedRows[0].Customer_id
    }

    const createDialogStylePT = {
      height: '600px',
      marginTop: '-20%',
      width: '850px',
      marginLeft: '-10%',
      left: '45%',
    };
    const customerLogsModalStyle = {
      height: '670px',
      marginTop: '-22%',
      width: '900px',
      left: '50%',
    };
    const giftcardModalStyle = {
      height: '670px',
      marginTop: '-350px',
      width: '900px',
      left: '50%',
    };
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="customers" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* Nav Trail */}

        <Grid fluid="true" id="customers-page">
          <h1><Translate value="manage_customers" /></h1>
          <Row>
            <Col xs={12}>
              <Panel className="position-relative mb0" style={tableCollapseFix}>
                <ButtonToolbar className="table-buttons" style={{ display: 'flex' }}>
                  <Button
                    bsStyle="success"
                    type="submit"
                    onClick={(event) => { this.clickNew(event); }}
                    disabled={!checkPermission('add_customer')}
                  >
                    <em className="fa fa-plus" /><Translate value="add" />
                  </Button>
                  <Button
                    bsStyle="warning"
                    type="button"
                    onClick={(event) => { this.setCurrentCustomer(event); }}
                    disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !checkPermission('change_customer')}
                  >
                    <em className="fa fa-pencil" /><Translate value="edit" />
                  </Button>
                  <Button
                    bsStyle="success"
                    type="button"
                    href={excelUrl}
                    disabled={(isGGI && !checkPermission('export_customer'))}
                  >
                    <em className="fa fa-download" /><Translate value="export" />
                  </Button>
                  {isSV && 
                   <Button
                   bsStyle="success"
                   type="button"
                   disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1}
                   href={excelShippingUrl}
                 >
                   <em className="fa fa-download" /><Translate value="shipping_address" />
                 </Button>
                  }
                  <Dropzone onDrop={this.onDrop.bind(this)} style={{ 'padding-left': '5px' }} className="upload-button">
                    <Button bsStyle="primary" disabled={!checkPermission('add_customer') || this.props.isAttachingDocument}>
                      <em className={`fa ${this.props.isAttachingDocument ? 'fa-spinner fa-spin' : 'fa-file-text'}`} />
                      <Translate value="upload_import" />
                    </Button>
                  </Dropzone>
                  {
                    (isLE || isNS) &&
                    <Button
                      bsStyle="success"
                      type="button"
                      onClick={() => this.openPTModal()}
                                    disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1}
                                    >
                      <em className="fa fa-pencil" /><Translate value="price_table" />
                    </Button>
                  }     
                  {
                    (isGGI || isSUN || isDAICHEONG) && (
                      <Button
                        bsStyle="primary"
                        href={`https://scmteambucket.s3.us-west-1.amazonaws.com/Customer+template.csv`}
                        >
                        <em className='fa fa-file-text' />
                        <Translate value="customer_upload_template" />
                      </Button>
                    )
                  }
                  {
                    (isEcity || isARC) && (
                      <Button
                        bsStyle="success"
                        type="button"
                        href={memberCardURL}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !this.state.selectedRows[0].MemberCard}
                      >
                        <em className="fa fa-download" /><Translate value="member_card" />
                      </Button>
                    )
                  }
                  {(isARC && true) && this.giftcardTransactionBtn()}
                  {isSV && this.renderCustomerLogBtn()}
                </ButtonToolbar>
                {/* Customers Table */}
                {this.renderSearchFilter()}
                {this.renderTable()}
              </Panel>
            </Col>
          </Row>
        </Grid>

        <SkyLightStateless dialogStyles={createDialogStylePT} isVisible={this.state.ptModalOpen} onCloseClicked={() => { this.closePTModal() }} title={<Translate value="price_table" />}>
            <PriceTableModal
              fjCustomerId={this.state.fjCustomerId}
              fetchPT={this.props.fetchPT}
              updatePT={this.props.updatePT}
              // deleteFJAgents = {this.props.deleteFJAgents}
              closePTModal={this.closePTModal}
              selectedWarehouse={this.props.selectedWarehouse}
            />
          </SkyLightStateless>
        <SkyLightStateless dialogStyles={customerLogsModalStyle} isVisible={this.state.customerLogModalVisibility} onCloseClicked={() => this.closeCustomerLogModal()} title={<Translate value="conversation_log" />}>
          <CustomerLogModal handleClose={this.closeCustomerLogModal} currentCustomer={this.state.selectedRows}/>
        </SkyLightStateless>
        <SkyLightStateless dialogStyles={giftcardModalStyle} isVisible={this.state.giftcardModalVisibility} onCloseClicked={() => this.closeGiftcardModal()} title={<Translate value="giftcard_transactions" />}>
        <Row>
            <Col xs={12}>
              <div style={{marginBottom: '10px'}}>
              <span style={{fontSize: '15px', fontWeight: 'bold'}}>CUSTOMER: {this.state.giftCustomer.Name}</span><span style={{marginLeft: '50px', fontSize: '14px', fontWeight: 'bold'}}>MEMBERSHIP: {this.state.giftCustomer.MemberCard}</span>
              </div>
              </Col>
              </Row>
<div style={{position: 'relative', zIndex: '900', width: '780px'}}>
          <Row>
            <Col xs={2}>
              <label style={{ width: '100%' }}><Translate value="giftcard_balance" />:</label>
            </Col>
            <Col xs={2}>
              <label style={{ width: '100%' }}><Translate value="reload_amount" />&nbsp;($):</label>
            </Col>
            <Col xs={4}>
              <label style={{ width: '100%' }}><Translate value="note" />:</label>
            </Col>
          </Row>
          <Row>
            <Col xs={2}>
              <p style={{marginTop: '3px', fontWeight: 'bold', marginLeft: '2px'}}>${this.state.giftCustomer.giftcard_balance}</p>
              {/* <input
                placeholder="Amount"
                value={this.state.giftCustomer.giftcard_balance}
                onChange={(e) =>
                  console.log("none")
                }
                disabled={true}
                style={{
                  outline: "none",
                  width: "100%",
                  height: "24px",
                  padding: "10px 10px",
                  fontFamily: "Helvetica, sans-serif",
                  fontWeight: "300",
                  fontSize: "12px",
                  border: "1px solid #aaa",
                  borderRadius: "4px",
                }}
              /> */}
            </Col>
            <Col xs={2}>
              <input
                placeholder="Amount"
                value={this.state.reloadAmount}
                onChange={(e) =>
                  this.setState({
                    reloadAmount: e.target.value,
                  })
                }
                style={{
                  outline: "none",
                  width: "100%",
                  height: "24px",
                  padding: "10px 10px",
                  fontFamily: "Helvetica, sans-serif",
                  fontWeight: "300",
                  fontSize: "12px",
                  border: "1px solid #aaa",
                  borderRadius: "4px",
                }}
              />
            </Col>
            <Col xs={4}>
              <input
                placeholder="Note"
                value={this.state.reloadNote}
                onChange={(e) =>
                  this.setState({
                    reloadNote: e.target.value,
                  })
                }
                style={{
                  outline: "none",
                  width: "100%",
                  height: "24px",
                  padding: "10px 10px",
                  fontFamily: "Helvetica, sans-serif",
                  fontWeight: "300",
                  fontSize: "12px",
                  border: "1px solid #aaa",
                  borderRadius: "4px",
                }}
              />
            </Col>
            <Col xs={2}>
              <Button bsStyle="success"
                disabled={!this.state.reloadAmount}
                onClick={() => this.confirmReload()}>
                {/* <em className={`fa fa-file-text`} /> */}
                <Translate value="reload" />
              </Button>
            </Col>

          </Row>
          </div>
          {this.renderGiftcardTable()}
        </SkyLightStateless>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default Customers;



// WEBPACK FOOTER //
// ./master/jsx/components/Customers/customers.jsx